import { createFileRoute } from '@tanstack/react-router';
import { redirectToHealthReadiness } from '@/components/health-readiness/legacy-redirect';

/**
 * The old Health Check → Synthesis tab (T-0224, T-0242): the synthesis is
 * now the one Health & readiness report, on the Report tab.
 */
export const Route = createFileRoute('/engagements/$engagementId/health/synthesis')({
  beforeLoad: ({ params }) => {
    throw redirectToHealthReadiness(params.engagementId, { tab: 'report' });
  },
});
